// extracted by mini-css-extract-plugin
export var banner = "_nf-0";
export var settingRow = "_nf-2";
export var titleIcon = "_nf-1";